import { render, staticRenderFns } from "./SmartApproachAppConfig.vue?vue&type=template&id=f43abbcc&"
import script from "./SmartApproachAppConfig.vue?vue&type=script&lang=ts&"
export * from "./SmartApproachAppConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports